import React from "react";
import ContactUs from "../components/ContactUs";

const ContactusPage = () => {
  return <ContactUs />;
};

export default ContactusPage;
